/* ═══════════════════════════════════════════
   NUVEMARCA · LANDING PAGE JS
   Comportamientos interactivos modulares
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Header & Announcement Bar scroll & sticky height sync ── */
  const header = document.getElementById('header');
  const getAnnounceBar = () => document.getElementById('announcement-bar') || document.getElementById('marquee') || document.querySelector('.announcement-bar, .marquee');

  const updateAnnouncementBarHeight = () => {
    const announceBar = getAnnounceBar();
    const sectionWrapper = announceBar ? (announceBar.closest('.shopify-section') || announceBar.parentElement) : null;
    const isHidden = !announceBar ||
      announceBar.offsetHeight === 0 ||
      window.getComputedStyle(announceBar).display === 'none' ||
      window.getComputedStyle(announceBar).visibility === 'hidden' ||
      (sectionWrapper && (window.getComputedStyle(sectionWrapper).display === 'none' || sectionWrapper.offsetHeight === 0));

    const headerSection = document.querySelector('#shopify-section-header, .shopify-section:has(> .header), .shopify-section:has(> #header)');

    if (!isHidden) {
      const h = announceBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${h}px`);
      if (headerSection) headerSection.style.setProperty('top', `${h}px`);
    } else {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      if (headerSection) headerSection.style.setProperty('top', '0px');
      if (header) header.style.setProperty('top', '0px');
    }
  };

  updateAnnouncementBarHeight();
  window.addEventListener('resize', updateAnnouncementBarHeight, { passive: true });
  document.addEventListener('shopify:section:load', updateAnnouncementBarHeight);
  document.addEventListener('shopify:section:unload', updateAnnouncementBarHeight);
  document.addEventListener('shopify:section:reorder', updateAnnouncementBarHeight);
  document.addEventListener('shopify:section:select', updateAnnouncementBarHeight);
  document.addEventListener('shopify:section:deselect', updateAnnouncementBarHeight);

  if ('MutationObserver' in window) {
    const observer = new MutationObserver(() => {
      updateAnnouncementBarHeight();
    });
    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  }

  /* ── Marquee Infinite Smooth Scroll (RAF Driver) ── */
  let marqueeRaf = null;
  const initMarquee = () => {
    let track = document.getElementById('marquee-track') || document.querySelector('.marquee-track, .marquee__track');

    // Fallback: if #marquee-track is not in DOM, adapt .announcement-bar__inner or .announcement-bar
    if (!track) {
      const inner = document.querySelector('.announcement-bar__inner');
      const bar = document.getElementById('announcement-bar') || document.querySelector('.announcement-bar');
      if (inner && bar) {
        bar.classList.add('marquee', 'marquee-bar');
        bar.style.overflow = 'hidden';
        bar.style.whiteSpace = 'nowrap';

        inner.classList.add('marquee-track');
        inner.style.display = 'inline-flex';
        inner.style.whiteSpace = 'nowrap';
        inner.style.width = 'max-content';
        inner.style.willChange = 'transform';

        if (!inner.dataset.duplicated) {
          const originalHTML = inner.innerHTML;
          inner.innerHTML = `<div class="marquee-content" style="display:inline-flex; align-items:center; gap:24px; padding-right:24px; flex-shrink:0;">${originalHTML}</div>` +
                            `<div class="marquee-content" style="display:inline-flex; align-items:center; gap:24px; padding-right:24px; flex-shrink:0;" aria-hidden="true">${originalHTML}</div>`;
          inner.dataset.duplicated = 'true';
        }
        track = inner;
      }
    }

    if (!track) return;

    // Ensure groups are wide enough so there is never any empty space on the right
    const groups = track.querySelectorAll('.marquee-content, .marquee__group');
    if (groups.length >= 2) {
      const group1 = groups[0];
      const group2 = groups[1];
      const minRequiredWidth = Math.max(window.innerWidth * 1.8, 3000);

      let safety = 0;
      const initialItemsHTML = group1.innerHTML;
      while (group1.offsetWidth < minRequiredWidth && safety < 10 && initialItemsHTML) {
        group1.innerHTML += initialItemsHTML;
        safety++;
      }
      group2.innerHTML = group1.innerHTML;
    }

    if (marqueeRaf) {
      cancelAnimationFrame(marqueeRaf);
      marqueeRaf = null;
    }

    let pos = 0;
    const barEl = document.getElementById('announcement-bar') || track.closest('.marquee-bar, .announcement-bar') || track;

    function getSpeed(halfWidth) {
      const barSpeedSec = parseFloat(barEl?.dataset?.speed || 30);
      return halfWidth > 0 ? Math.max(0.1, halfWidth / (barSpeedSec * 60)) : 0.8;
    }

    function step() {
      const currentGroups = track.querySelectorAll('.marquee-content, .marquee__group');
      const halfWidth = currentGroups.length > 0 ? currentGroups[0].offsetWidth : (track.scrollWidth / 2);
      if (halfWidth > 0) {
        const speed = getSpeed(halfWidth);
        pos += speed;
        if (pos >= halfWidth) {
          pos -= halfWidth;
        }
        track.style.transform = `translate3d(-${pos.toFixed(2)}px, 0, 0)`;
      }
      marqueeRaf = requestAnimationFrame(step);
    }

    marqueeRaf = requestAnimationFrame(step);
  };

  initMarquee();
  document.addEventListener('shopify:section:load', initMarquee);

  /* ── Order form section wrapper zero-padding & matching background enforcement ── */
  const fixOrderFormWrapper = () => {
    const orderForm = document.getElementById('order-form') || document.querySelector('.order-section');
    if (!orderForm) return;

    const sectionWrapper = orderForm.closest('.shopify-section') || document.querySelector('[id*="__order_form"]');
    if (sectionWrapper) {
      sectionWrapper.style.setProperty('padding-top', '0px', 'important');
      sectionWrapper.style.setProperty('padding-bottom', '0px', 'important');
      sectionWrapper.style.setProperty('margin-top', '0px', 'important');
      sectionWrapper.style.setProperty('margin-bottom', '0px', 'important');

      const bg = window.getComputedStyle(orderForm).backgroundColor;
      if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') {
        sectionWrapper.style.setProperty('background-color', bg, 'important');
      } else {
        sectionWrapper.style.setProperty('background-color', '#ECECEC', 'important');
      }
    }
  };

  fixOrderFormWrapper();
  document.addEventListener('shopify:section:load', fixOrderFormWrapper);
  document.addEventListener('DOMContentLoaded', fixOrderFormWrapper);

  window.addEventListener('scroll', () => {
    if (header) {
      if (window.scrollY > 80) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }
  }, { passive: true });

  /* ── Sticky bottom bar (mobile / desktop) ── */
  function initStickyBar() {
    const stickyBar = document.getElementById('sticky-bar');
    if (!stickyBar) return;
    const heroSection = document.getElementById('hero');

    const updateStickyBarHeight = () => {
      if (stickyBar.classList.contains('visible') && stickyBar.offsetHeight > 0) {
        let h = stickyBar.offsetHeight;
        const esSticky = document.getElementById('es-sticky') || document.querySelector('.es-sticky-btn');
        if (esSticky && esSticky.offsetHeight > 0) {
          const rectBar = stickyBar.getBoundingClientRect();
          const rectEs = esSticky.getBoundingClientRect();
          const topEdge = Math.min(rectBar.top, rectEs.top);
          const bottomEdge = Math.max(rectBar.bottom, rectEs.bottom);
          if (bottomEdge > topEdge && topEdge < window.innerHeight) {
            h = Math.max(h, Math.round(window.innerHeight - topEdge));
          }
        }
        document.documentElement.style.setProperty('--sticky-bar-height', `${h}px`);
      } else {
        document.documentElement.style.setProperty('--sticky-bar-height', '0px');
      }
    };

    const rawThreshold = stickyBar.getAttribute('data-scroll-threshold');
    const scrollThreshold = rawThreshold !== null && rawThreshold !== '' ? parseInt(rawThreshold, 10) : 400;

    if (scrollThreshold > 0) {
      const checkStickyScroll = () => {
        const scrolled = window.scrollY || window.pageYOffset || 0;
        if (scrolled >= scrollThreshold) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
        updateStickyBarHeight();
      };
      window.addEventListener('scroll', checkStickyScroll, { passive: true });
      checkStickyScroll();
    } else if (heroSection) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('visible');
          } else {
            stickyBar.classList.remove('visible');
          }
          updateStickyBarHeight();
        },
        { threshold: 0 }
      );
      observer.observe(heroSection);
    } else {
      const checkStickyScroll = () => {
        const scrolled = window.scrollY || window.pageYOffset || 0;
        if (scrolled >= 400) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
        updateStickyBarHeight();
      };
      window.addEventListener('scroll', checkStickyScroll, { passive: true });
      checkStickyScroll();
    }

    window.addEventListener('resize', updateStickyBarHeight, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateStickyBarHeight).observe(stickyBar);
    }
  }
  initStickyBar();
  document.addEventListener('shopify:section:load', initStickyBar);

  /* ── Image gallery thumbnails & Slider ── */
  const mainImg = document.getElementById('product-image-1');
  const thumbs = document.querySelectorAll('.thumb');
  const thumbPrev = document.getElementById('thumb-prev');
  const thumbNext = document.getElementById('thumb-next');
  const thumbTrack = document.getElementById('hero-thumbnails');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const newSrc = thumb.dataset.img;
      if (mainImg && newSrc) {
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(.97)';
        mainImg.style.transition = 'opacity 200ms ease, transform 200ms ease';
        setTimeout(() => {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 200);
      }
      thumbs.forEach(t => t.classList.remove('thumb--active'));
      thumb.classList.add('thumb--active');
    });
  });

  if (thumbTrack && thumbPrev && thumbNext) {
    const wrapper = document.getElementById('hero-thumbnails-wrapper');
    const updateNavState = () => {
      const thumbs = thumbTrack.querySelectorAll('.thumb');
      const totalThumbs = thumbs.length;
      const maxScroll = thumbTrack.scrollWidth - thumbTrack.clientWidth;
      const hasOverflow = totalThumbs > 4 && maxScroll > 4;

      if (!hasOverflow) {
        if (wrapper) wrapper.classList.add('has-no-scroll');
        thumbPrev.style.display = 'none';
        thumbNext.style.display = 'none';
        thumbTrack.style.justifyContent = 'center';
      } else {
        if (wrapper) wrapper.classList.remove('has-no-scroll');
        thumbPrev.style.display = 'flex';
        thumbNext.style.display = 'flex';
        thumbTrack.style.justifyContent = 'flex-start';

        // Ocultar botón si no hay más fotos en esa dirección
        if (thumbTrack.scrollLeft <= 4) {
          thumbPrev.style.visibility = 'hidden';
          thumbPrev.style.pointerEvents = 'none';
        } else {
          thumbPrev.style.visibility = 'visible';
          thumbPrev.style.pointerEvents = 'auto';
        }

        if (thumbTrack.scrollLeft >= maxScroll - 4) {
          thumbNext.style.visibility = 'hidden';
          thumbNext.style.pointerEvents = 'none';
        } else {
          thumbNext.style.visibility = 'visible';
          thumbNext.style.pointerEvents = 'auto';
        }
      }
    };

    const getScrollStep = () => {
      const firstThumb = thumbTrack.querySelector('.thumb');
      if (!firstThumb) return 100;
      const style = window.getComputedStyle(thumbTrack);
      const gap = parseFloat(style.gap) || 8;
      return firstThumb.offsetWidth + gap;
    };

    thumbPrev.addEventListener('click', () => {
      thumbTrack.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });

    thumbNext.addEventListener('click', () => {
      thumbTrack.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });

    thumbTrack.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState, { passive: true });
    // Initial check
    setTimeout(updateNavState, 150);
  }

  /* ── Testimonios: Carrusel, Dots y Desplazamiento Suave ── */
  function initTestimonials() {
    const testCarousel = document.getElementById('testimonials-carousel');
    const testTrack = document.getElementById('testimonials-track');
    const dotsContainer = document.getElementById('carousel-dots');

    if (!testCarousel || !testTrack) return;

    const cards = Array.from(testTrack.querySelectorAll('.review-card'));
    const N = cards.length;
    if (N === 0) return;

    // Asegurar y enlazar dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (let i = 0; i < N; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `carousel-dot${i === 0 ? ' active' : ''}`;
        dot.setAttribute('aria-label', `Ver testimonio ${i + 1}`);
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goToSlide(i);
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateActiveDot(idx) {
      if (!dotsContainer) return;
      const dots = dotsContainer.querySelectorAll('.carousel-dot');
      dots.forEach((d, i) => {
        if (i === idx) d.classList.add('active');
        else d.classList.remove('active');
      });
    }

    function getClosestIndex() {
      const carouselLeft = testCarousel.getBoundingClientRect().left;
      let closest = 0;
      let minDiff = Infinity;
      cards.forEach((card, idx) => {
        const diff = Math.abs(card.getBoundingClientRect().left - carouselLeft);
        if (diff < minDiff) {
          minDiff = diff;
          closest = idx;
        }
      });
      return closest;
    }

    function goToSlide(idx) {
      let targetIdx = idx;
      if (targetIdx < 0) targetIdx = 0;
      if (targetIdx >= N) targetIdx = 0;
      const targetCard = cards[targetIdx];
      if (!targetCard) return;

      const targetLeft = targetCard.offsetLeft - testTrack.offsetLeft;
      testCarousel.scrollTo({
        left: targetLeft,
        behavior: 'smooth'
      });
      updateActiveDot(targetIdx);
    }

    let scrollDebounce;
    testCarousel.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        updateActiveDot(getClosestIndex());
      }, 60);
    }, { passive: true });

    // Arrastre con mouse (Mouse Drag)
    let isDown = false;
    let startX = 0;
    let scrollLeftStart = 0;

    testCarousel.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - testCarousel.offsetLeft;
      scrollLeftStart = testCarousel.scrollLeft;
      testCarousel.style.scrollBehavior = 'auto';
      testCarousel.style.scrollSnapType = 'none';
    });

    const stopDrag = () => {
      if (!isDown) return;
      isDown = false;
      testCarousel.style.scrollBehavior = 'smooth';
      testCarousel.style.scrollSnapType = 'x mandatory';
      updateActiveDot(getClosestIndex());
    };

    testCarousel.addEventListener('mouseleave', stopDrag);
    testCarousel.addEventListener('mouseup', stopDrag);

    testCarousel.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - testCarousel.offsetLeft;
      const walk = (x - startX) * 1.5;
      testCarousel.scrollLeft = scrollLeftStart - walk;
    });

    // Auto-desplazamiento cada 5s cuando esté en vista
    let isVisible = false;
    const testSection = document.getElementById('testimonios');
    if (testSection && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        isVisible = entry.isIntersecting;
      }, { threshold: 0.2 }).observe(testSection);
    }

    if (window._testimonialsTimer) clearInterval(window._testimonialsTimer);
    window._testimonialsTimer = setInterval(() => {
      if (!isDown && isVisible) {
        const current = getClosestIndex();
        const next = (current + 1) % N;
        goToSlide(next);
      }
    }, 5000);
  }

  initTestimonials();
  window.addEventListener('load', initTestimonials);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector('#testimonials-carousel')) {
      initTestimonials();
    }
  });

  /* ── Botón Volver Arriba (Flotante) ── */
  function initBackToTop() {
    const btn = document.getElementById('back-to-top-btn');
    if (!btn) return;
    const threshold = parseInt(btn.dataset.scrollThreshold, 10) || 400;
    const checkScroll = () => {
      if (window.scrollY > threshold) {
        btn.classList.add('visible');
      } else {
        btn.classList.remove('visible');
      }
    };
    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();

    btn.onclick = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  }
  initBackToTop();
  document.addEventListener('shopify:section:load', initBackToTop);

  /* ── FAQ Accordion (Delegado en document para compatibilidad total con Shopify Theme Editor y Frontend) ── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.faq-item__question');
    if (!btn) return;
    const item = btn.closest('.faq-item');
    if (!item) return;
    const answer = item.querySelector('.faq-item__answer');
    if (!answer) return;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    const list = item.closest('.faq__list') || document;

    // Cerrar todas las demás
    list.querySelectorAll('.faq-item').forEach(otherItem => {
      const otherBtn = otherItem.querySelector('.faq-item__question');
      const otherAns = otherItem.querySelector('.faq-item__answer');
      if (otherBtn && otherAns) {
        otherBtn.setAttribute('aria-expanded', 'false');
        otherAns.classList.remove('open');
      }
    });

    // Abrir la clickeada si no estaba abierta
    if (!isOpen) {
      btn.setAttribute('aria-expanded', 'true');
      answer.classList.add('open');
    }
  });

  /* ── Hero Collapsibles Accordion (Solo una abierta a la vez) ── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.collapsible-header');
    if (!btn) return;
    const item = btn.closest('.collapsible-item');
    if (!item) return;
    const body = item.querySelector('.collapsible-body');
    if (!body) return;

    const isCurrentlyOpen = btn.getAttribute('aria-expanded') === 'true';

    // Cerrar todas las demás pestañas del mismo contenedor
    const container = item.closest('.hero__content') || item.parentElement || document;
    container.querySelectorAll('.collapsible-item').forEach(otherItem => {
      const otherBtn = otherItem.querySelector('.collapsible-header');
      const otherBody = otherItem.querySelector('.collapsible-body');
      if (otherBtn && otherBody) {
        otherBtn.setAttribute('aria-expanded', 'false');
        otherBody.classList.remove('open');
      }
    });

    // Si la clickeada no estaba abierta, abrirla
    if (!isCurrentlyOpen) {
      btn.setAttribute('aria-expanded', 'true');
      body.classList.add('open');
    }
  });

  /* ── Sincronización de paquetes (Hero <-> Bottom) y actualización de precios ── */
  const heroRadios = document.querySelectorAll('[name="package"]');
  const bottomRadios = document.querySelectorAll('[name="bottom-package"]');

  // Sincronizar selección de radio entre Hero y Sección de Pedido inferior
  function syncHeroAndBottomPackages() {
    // Si no hay bottom, no hace falta
    const bottomRadiosList = document.querySelectorAll('[name="bottom-package"]');
    const heroRadiosList = document.querySelectorAll('[name="package"]');
    if (!bottomRadiosList.length || !heroRadiosList.length) return;

    // Sincronizar el radio seleccionado inicialmente
    let selectedVal = '1';
    heroRadiosList.forEach(r => { if (r.checked) selectedVal = r.value; });
    bottomRadiosList.forEach(r => { if (r.value === selectedVal) r.checked = true; });
  }
  syncHeroAndBottomPackages();
  window.addEventListener('load', syncHeroAndBottomPackages);

  function parsePrice(str) {
    if (!str) return 0;
    const digits = str.replace(/[^\d]/g, '');
    return parseInt(digits, 10) || 0;
  }

  function formatPrice(num) {
    if (!num || isNaN(num)) return '';
    return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  let cachedBasePricing = null;

  function getBasePriceData() {
    if (cachedBasePricing) return cachedBasePricing;

    const p1El = document.getElementById('pkg-1') || document.getElementById('bottom-pkg-1');
    const p1PriceText = (p1El && p1El.querySelector('.package__price')) ? p1El.querySelector('.package__price').textContent.trim() : '';
    const p1Num = parsePrice(p1PriceText) || 0;

    const initialHeroOrigEl = document.getElementById('price-compare') || document.getElementById('bottom-price-original');
    const initialHeroCurrEl = document.getElementById('price-current') || document.getElementById('bottom-price-current');
    const initialHeroSaveEl = document.getElementById('price-badge') || document.getElementById('bottom-price-save');

    let initialSave = initialHeroSaveEl ? initialHeroSaveEl.textContent.trim() : '';
    if (initialSave === '$0' || initialSave === '0') {
      initialSave = '';
    }

    cachedBasePricing = {
      original: initialHeroOrigEl ? initialHeroOrigEl.textContent.trim() : '',
      current: initialHeroCurrEl ? initialHeroCurrEl.textContent.trim() : p1PriceText,
      save: initialSave
    };

    return cachedBasePricing;
  }

  function getDynamicPackageData(val) {
    const base = getBasePriceData();
    const p1El = document.getElementById('pkg-1') || document.getElementById('bottom-pkg-1');
    const p1PriceText = (p1El && p1El.querySelector('.package__price')) ? p1El.querySelector('.package__price').textContent.trim() : base.current;
    const p1Num = parsePrice(p1PriceText) || 0;

    let current = '';
    let original = '';
    let save = '';

    if (val === '1') {
      current = p1PriceText;
      original = base.original;
      save = (base.save && base.save !== '$0' && base.save !== '0') ? base.save : '';
    } else if (val === '2') {
      const p2El = document.getElementById('pkg-2') || document.getElementById('bottom-pkg-2');
      const p2PriceText = (p2El && p2El.querySelector('.package__price')) ? p2El.querySelector('.package__price').textContent.trim() : '';
      const p2Num = parsePrice(p2PriceText) || Math.round(p1Num * 1.6);
      const orig2Num = p1Num ? p1Num * 2 : 0;
      const save2Num = orig2Num - p2Num;

      current = p2PriceText || formatPrice(p2Num);
      original = orig2Num > 0 ? formatPrice(orig2Num) : '';
      save = (save2Num > 0) ? `Ahorras ${formatPrice(save2Num)}` : '';
    } else if (val === '3') {
      const p3El = document.getElementById('pkg-3') || document.getElementById('bottom-pkg-3');
      const p3PriceText = (p3El && p3El.querySelector('.package__price')) ? p3El.querySelector('.package__price').textContent.trim() : '';
      const p3Num = parsePrice(p3PriceText) || Math.round(p1Num * 2.1);
      const orig3Num = p1Num ? p1Num * 3 : 0;
      const save3Num = orig3Num - p3Num;

      current = p3PriceText || formatPrice(p3Num);
      original = orig3Num > 0 ? formatPrice(orig3Num) : '';
      save = (save3Num > 0) ? `Ahorras ${formatPrice(save3Num)}` : '';
    }

    return { current, original, save };
  }

  function updatePrices(val) {
    const data = getDynamicPackageData(val);
    if (!data) return;

    const hasDiscount = Boolean(data.save && data.save !== '$0' && data.save !== '0' && data.save.trim() !== '');

    const bottomOrig = document.getElementById('bottom-price-original');
    const bottomCurr = document.getElementById('bottom-price-current');
    const bottomSave = document.getElementById('bottom-price-save');

    if (bottomOrig) {
      if (data.original) {
        bottomOrig.textContent = data.original;
        bottomOrig.style.display = '';
      } else {
        bottomOrig.textContent = '';
        bottomOrig.style.display = 'none';
      }
    }
    if (bottomCurr && data.current) bottomCurr.textContent = data.current;
    if (bottomSave) {
      if (hasDiscount) {
        bottomSave.textContent = data.save;
        bottomSave.style.display = '';
      } else {
        bottomSave.textContent = '';
        bottomSave.style.display = 'none';
      }
    }

    const heroOrig = document.getElementById('price-compare');
    const heroCurr = document.getElementById('price-current');
    const heroSave = document.getElementById('price-badge');

    if (heroOrig) {
      if (data.original) {
        heroOrig.textContent = data.original;
        heroOrig.style.display = '';
      } else {
        heroOrig.textContent = '';
        heroOrig.style.display = 'none';
      }
    }
    if (heroCurr && data.current) heroCurr.textContent = data.current;
    if (heroSave) {
      if (hasDiscount) {
        heroSave.textContent = data.save;
        heroSave.style.display = '';
      } else {
        heroSave.textContent = '';
        heroSave.style.display = 'none';
      }
    }
  }

  heroRadios.forEach((radio, i) => {
    radio.addEventListener('change', () => {
      if (bottomRadios[i]) bottomRadios[i].checked = true;
      updatePrices(radio.value);
    });
  });
  bottomRadios.forEach((radio, i) => {
    radio.addEventListener('change', () => {
      if (heroRadios[i]) heroRadios[i].checked = true;
      updatePrices(radio.value);
    });
  });

  // Asegurar que al cargar la página el paquete 1 esté seleccionado y el precio a la vista sea el del paquete 1
  const pkg1Hero = document.querySelector('[name="package"][value="1"]');
  const pkg1Bottom = document.querySelector('[name="bottom-package"][value="1"]');
  if (pkg1Hero) pkg1Hero.checked = true;
  if (pkg1Bottom) pkg1Bottom.checked = true;
  updatePrices('1');

  /* ── Botón Confirmar Pedido (Bottom) ── */
  const btnBottomSubmit = document.getElementById('btn-bottom-submit');
  if (btnBottomSubmit) {
    btnBottomSubmit.addEventListener('click', () => {
      btnBottomSubmit.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke-opacity=".3"/><path d="M12 2a10 10 0 0 1 10 10"/></svg>
        Procesando pedido...
      `;
      btnBottomSubmit.style.opacity = '.85';
      setTimeout(() => {
        btnBottomSubmit.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
          ¡Pedido registrado con éxito!
        `;
        btnBottomSubmit.style.background = 'var(--success)';
        btnBottomSubmit.style.borderColor = 'var(--success)';
      }, 1000);
    });
  }

  /* ── Smooth scroll para links de ancla ── */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = header ? header.offsetHeight + 20 : 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* ═══════════════════════════════════════════
     MODO PREVISUALIZADOR (postMessage listener)
     Resaltado de bloques desde previewer.html
     ═══════════════════════════════════════════ */
  let currentHighlightedEl = null;
  let currentHighlighterOverlay = null;

  function removeHighlight() {
    if (currentHighlightedEl) {
      currentHighlightedEl.classList.remove('ms-highlighted-block');
      currentHighlightedEl = null;
    }
    if (currentHighlighterOverlay) {
      currentHighlighterOverlay.style.display = 'none';
    }
  }

  function highlightBlock(blockId, blockName, blockIcon, spotlight) {
    removeHighlight();

    const el = document.getElementById(blockId);
    if (!el) return;

    currentHighlightedEl = el;
    el.classList.add('ms-highlighted-block');

    // Scroll suave hacia la sección
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Crear overlay si no existe
    let hl = document.getElementById('ms-highlighter-overlay');
    if (!hl) {
      hl = document.createElement('div');
      hl.id = 'ms-highlighter-overlay';
      hl.innerHTML = `
        <div class="ms-hl__badge" id="ms-hl-badge">
          <span class="ms-hl__icon"></span>
          <span class="ms-hl__title"></span>
          <span class="ms-hl__id"></span>
          <span class="ms-hl__dim"></span>
        </div>
        <div class="ms-hl__corner tl"></div>
        <div class="ms-hl__corner tr"></div>
        <div class="ms-hl__corner bl"></div>
        <div class="ms-hl__corner br"></div>
        <div class="ms-hl__dim-pill-bottom" id="ms-hl-dim-bottom">0px</div>
      `;
      document.body.appendChild(hl);
    }
    currentHighlighterOverlay = hl;

    // Actualizar badge
    hl.querySelector('.ms-hl__icon').textContent = blockIcon || '🔷';
    hl.querySelector('.ms-hl__title').textContent = blockName || 'Bloque';
    hl.querySelector('.ms-hl__id').textContent = `#${blockId}`;

    function updateRect() {
      if (!currentHighlightedEl || currentHighlightedEl !== el) return;
      const rect = el.getBoundingClientRect();
      const scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

      hl.style.display = 'block';
      hl.style.top = Math.round(rect.top + scrollY) + 'px';
      hl.style.left = Math.round(rect.left + scrollX) + 'px';
      hl.style.width = Math.round(rect.width) + 'px';
      hl.style.height = Math.round(rect.height) + 'px';

      if (spotlight) {
        hl.classList.add('is-spotlight');
      } else {
        hl.classList.remove('is-spotlight');
      }

      const badge = hl.querySelector('#ms-hl-badge');
      const dimBadge = hl.querySelector('.ms-hl__dim');
      const dimBottom = hl.querySelector('#ms-hl-dim-bottom');

      const dimText = `${Math.round(rect.width)} × ${Math.round(rect.height)}px`;
      if (dimBadge) dimBadge.textContent = dimText;
      if (dimBottom) dimBottom.textContent = `${Math.round(rect.height)}px de alto`;

      if (badge) {
        if (rect.top + scrollY < 40) {
          badge.classList.add('inside-top');
        } else {
          badge.classList.remove('inside-top');
        }
      }
    }

    updateRect();

    // Notificar al padre sobre las dimensiones
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({
        type: 'MS_BLOCK_DIMENSIONS',
        width: Math.round(el.offsetWidth),
        height: Math.round(el.offsetHeight)
      }, '*');
    }
  }

  // Recibir mensajes desde el previsualizador
  window.addEventListener('message', (e) => {
    const data = e.data;
    if (!data || typeof data !== 'object') return;

    if (data.type === 'MS_SELECT_BLOCK') {
      highlightBlock(data.blockId, data.blockName, data.blockIcon, data.spotlight);
    } else if (data.type === 'MS_DESELECT_BLOCK') {
      removeHighlight();
    } else if (data.type === 'MS_TOGGLE_SPOTLIGHT') {
      if (currentHighlighterOverlay) {
        if (data.spotlight) currentHighlighterOverlay.classList.add('is-spotlight');
        else currentHighlighterOverlay.classList.remove('is-spotlight');
      }
    } else if (data.type === 'MS_UPDATE_POSITION') {
      if (currentHighlightedEl && currentHighlighterOverlay) {
        const rect = currentHighlightedEl.getBoundingClientRect();
        const scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
        const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        currentHighlighterOverlay.style.top = Math.round(rect.top + scrollY) + 'px';
        currentHighlighterOverlay.style.left = Math.round(rect.left + scrollX) + 'px';
        currentHighlighterOverlay.style.width = Math.round(rect.width) + 'px';
        currentHighlighterOverlay.style.height = Math.round(rect.height) + 'px';
      }
    } else if (data.type === 'MS_SET_ACCENT_COLOR') {
      const color = data.color;
      document.documentElement.style.setProperty('--accent', color);
      try {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        const hoverR = Math.max(0, Math.round(r * 0.85));
        const hoverG = Math.max(0, Math.round(g * 0.85));
        const hoverB = Math.max(0, Math.round(b * 0.85));
        const hoverHex = `#${hoverR.toString(16).padStart(2, '0')}${hoverG.toString(16).padStart(2, '0')}${hoverB.toString(16).padStart(2, '0')}`;
        document.documentElement.style.setProperty('--accent-hover', hoverHex);
        document.documentElement.style.setProperty('--accent-light', `rgba(${r}, ${g}, ${b}, 0.12)`);
      } catch(e) {}
    }
  });

  // Avisar al padre si el usuario hace clic en una sección dentro de la landing
  document.addEventListener('click', (e) => {
    const selectorList = [
      '#announcement-bar', '#header', '#hero', '#hero-packages', '#hero-trust',
      '#problem-solution', '#beneficios',
      '#banner-feature', '#testimonios', '#faq', '#order-form', '#footer', '#sticky-bar'
    ].join(',');
    const sec = e.target.closest(selectorList);
    if (sec && sec.id && window.parent && window.parent !== window) {
      window.parent.postMessage({ type: 'MS_BLOCK_CLICKED', blockId: sec.id }, '*');
    }
  }, true);

  // Reajustar overlay al cambiar tamaño de ventana
  window.addEventListener('resize', () => {
    if (currentHighlightedEl && currentHighlighterOverlay) {
      const rect = currentHighlightedEl.getBoundingClientRect();
      const scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      currentHighlighterOverlay.style.top = Math.round(rect.top + scrollY) + 'px';
      currentHighlighterOverlay.style.left = Math.round(rect.left + scrollX) + 'px';
      currentHighlighterOverlay.style.width = Math.round(rect.width) + 'px';
      currentHighlighterOverlay.style.height = Math.round(rect.height) + 'px';
    }
  });

  /* ── EasySell COD Live Color Sync & Black Border Removal ── */
  function cleanEasySellBorders() {
    var accentColor = (getComputedStyle(document.documentElement).getPropertyValue('--accent') || '#0071E3').trim();
    var selectedCards = document.querySelectorAll(
      '#easysell [offer-selected], #easysell-modal [offer-selected], .es-modal [offer-selected], .es-form-container [offer-selected], [offer-selected], .es-b-card[offer-selected], .es-b-standard-row[offer-selected], .es-qo-container[offer-selected], .es-selected'
    );
    selectedCards.forEach(function(card) {
      card.style.setProperty('border-color', accentColor, 'important');
      card.style.setProperty('outline', 'none', 'important');
      card.style.setProperty('box-shadow', 'none', 'important');
      card.style.setProperty('--eso-border-color', accentColor, 'important');

      var inners = card.querySelectorAll('div, .es-b-standard-header, .es-b-card, .es-b-standard-row');
      inners.forEach(function(el) {
        if (!el.classList.contains('offer-radio') && !el.classList.contains('es-variant-img')) {
          el.style.setProperty('outline', 'none', 'important');
          el.style.setProperty('box-shadow', 'none', 'important');
          if (el !== card) {
            el.style.setProperty('border-color', 'transparent', 'important');
          }
        }
      });
    });
  }

  cleanEasySellBorders();
  var esPollCount = 0;
  var esPollTimer = setInterval(function() {
    cleanEasySellBorders();
    esPollCount++;
    if (esPollCount > 25) clearInterval(esPollTimer);
  }, 250);

  try {
    var esObserver = new MutationObserver(function() {
      cleanEasySellBorders();
    });
    esObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['offer-selected', 'class', 'style'] });
  } catch (e) {}

});


